/**
 * Firebase options for the same project (padel-5s).
 * Capacitor iOS runs in a WKWebView at capacitor://localhost — the *Web* API key is often
 * restricted to HTTP referrers, which breaks signInWithCredential (auth/invalid-credential).
 * The iOS app's key from GoogleService-Info.plist must be used when the native iOS shell loads first.
 */
import { Capacitor } from '@capacitor/core';

export const firebaseConfigWeb = {
  apiKey: 'AIzaSyAWFzAfB08f1Lq8K0omqM0o4KeJgNCC9hU',
  authDomain: 'padel-5s.firebaseapp.com',
  projectId: 'padel-5s',
  storageBucket: 'padel-5s.firebasestorage.app',
  messagingSenderId: '70606646192',
  appId: '1:70606646192:web:0db57d1662c78560b50477',
  measurementId: 'G-4KJTRHK53Z',
};

/** Matches ios/App/App/GoogleService-Info.plist (iOS Firebase app). */
export const firebaseConfigIos = {
  apiKey: 'AIzaSyDQTbcyJEP5PGa0jwiHUApbQPaXjXMsqhA',
  authDomain: 'padel-5s.firebaseapp.com',
  projectId: 'padel-5s',
  storageBucket: 'padel-5s.firebasestorage.app',
  messagingSenderId: '70606646192',
  appId: '1:70606646192:ios:d2538e29559349d8b50475',
  measurementId: 'G-4KJTRHK53Z',
};

export function getFirebaseConfig() {
  try {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return firebaseConfigIos;
    }
  } catch (_) {
    /* tests / SSR */
  }
  return firebaseConfigWeb;
}
